import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useAddProphetRule } from '../../api/addRule';
import { ChunkPlatform } from '../../utils/chunk-limits';

import { RuleForm } from './RuleForm/RuleForm';

import { prophetTypes } from '@/features/prophet';

export const AddModal = NiceModal.create(
  ({
    appPageId,
    pageId,
    rule,
    platform,
  }: {
    appPageId: string;
    pageId: string;
    rule?: prophetTypes.Rule;
    platform: ChunkPlatform;
  }) => {
    const modal = useModal();

    const addProphetRule = useAddProphetRule({ pageId, config: { onSuccess: modal.hide } });

    return (
      <Modal
        title="Новое правило"
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={modal.remove}
        closeOnEscape={!addProphetRule.isLoading}
        closeOnClickOutside={!addProphetRule.isLoading}
        withCloseButton={!addProphetRule.isLoading}
        scrollAreaComponent={ScrollArea.Autosize}
      >
        {addProphetRule.isLoading && <Overlay opacity={0} />}
        <RuleForm
          onSubmit={(data) => addProphetRule.mutate({ ...data, page: { _id: pageId } })}
          appPageId={appPageId}
          isLoading={addProphetRule.isLoading}
          isKeywordInputDisabled={false}
          platform={platform}
          initialValues={
            rule && {
              actions: rule.actions,
              requirements: rule.requirements,
              messages: rule.messages,
              intervals: rule.intervals,
              isDiscountRequired: rule.isDiscountRequired,
              isSpreadKickRequired: rule.isSpreadKickRequired,
            }
          }
        />
      </Modal>
    );
  }
);
